import { DefaultError, useQuery } from "@tanstack/react-query";

import { IAuthUser } from "./types";
import { useResponseHandler } from "utils/service/responseHandler";
import { apiClient } from "utils";
import { cacheService } from "utils/service/cacheService";

export const useGetAuthUser = () => {
  const { responseHandler } = useResponseHandler();

  return useQuery<IAuthUser, DefaultError>({
    queryKey: ["auth-user"],
    async queryFn() {
      const response = await apiClient({
        method: "GET",
        url: `Auth/User`, // jeśli masz inną ścieżkę w swaggerze, podmień tutaj
      });

      return responseHandler(response, {
        groupName: `useGetAuthUser`,
      });
    },
    ...cacheService(),
  });
};
